import { render, staticRenderFns } from "./distributionRules.vue?vue&type=template&id=6a181ce6&scoped=true&"
import script from "./distributionRules.vue?vue&type=script&lang=ts&"
export * from "./distributionRules.vue?vue&type=script&lang=ts&"
import style0 from "./distributionRules.vue?vue&type=style&index=0&id=6a181ce6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a181ce6",
  null
  
)

export default component.exports